import { getAxiosInstance } from '../client';
export const challengeMutations = {
    /**
     * Advances the participant's virtual clock to an absolute target offset
     * (PRD #918, slice 3 / #921). The server enforces forward-only, so a
     * target ≤ the current offset is rejected with 400. Called by the
     * time-jump buttons in `ChallengePanel.vue` with
     * `targetOffsetMs = currentOffsetMs + delta`.
     */
    advanceClock: (targetOffsetMs) => getAxiosInstance()
        .post('/challenge/clock/advance', { targetOffsetMs })
        .then((r) => r.data),
};
//# sourceMappingURL=challenge.mutations.js.map